import withItemSelectionManager from '../hoc/withItemSelectionManager';
import DropdownItemGroup from './DropdownItemGroup';
export default withItemSelectionManager(DropdownItemGroup, 'radio');
//# sourceMappingURL=DropdownItemGroupRadio.js.map